import { ChakraStylesConfig } from "chakra-react-select";

export const BASE_CHAKRA_STYLES: ChakraStylesConfig<any> = {
  multiValue: provided => ({
    ...provided,
    bg: "basic.500",
    color: "#fff"
  }),
  option: (provided, state) => ({
    ...provided,
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    bg: state.isSelected
      ? "basic.500"
      : state.isFocused
      ? "gray.100"
      : "transparent",
    color: state.isSelected ? "white" : "gray.800",
    m: "4px",
    width: "initial",
    borderRadius: "6px",
    wordBreak: "break-word",
    "> span": {
      marginRight: 0
    }
  }),
  singleValue: () => ({}),
  menuList: provided => ({
    ...provided,
    py: 0,
    borderRadius: "8px"
  }),
  menu: provided => ({
    ...provided,
    zIndex: 2,
    overflow: "initial"
  })
};
